import { Component, OnInit, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { AbstractFilterComponent } from '../abstract-filter.component';
import { GroupConf, SelectItem, ConvertTypeTransformConf } from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-group-etl',
    templateUrl: './group-etl.component.html',
    styleUrls: ['./group-etl.component.scss'],
    standalone: false
})
export class GroupEtlComponent extends AbstractFilterComponent implements OnInit {

  @Input() group: GroupConf;
  @Output() groupChange = new EventEmitter<GroupConf>();
  enableGroup: boolean = false;
  numberTypes: SelectItem[]=[];
  constructor() {
    super();
    this.populateNumberType();
  }

  ngOnInit() {
    if(this.group){
      this.itemCol = this.group.byField;
    }
    this.updateListCol();
    this.enableGroup = this.group == null ? false : true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cols) {
      this.updateListCol();
    }
  }

  changeActiveGroup() {
    if (this.enableGroup) {
      this.group = {
        byField: null,
        fusionActions: [],
        groupOperator: "EQUALS"
      }
    } else {
      this.group = null;
    }
    this.groupChange.emit(this.group);
  }

  addFusion() {
    this.group.fusionActions.push({
      action: "ADITION",
      field: null,
      typeField: ConvertTypeTransformConf.TypeEnum.Int
    })
  }

  removeFusion(index:number){
    this.group.fusionActions.splice(index, 1);
    this.groupChange.emit(this.group);
  }

  updateExampleFusion(item) {
    if (item.field) {
      let col = this.cols.find(c => c.code == item.field);
      item.example = col.exampleValues.join(", ")
    } else {
      item.example = null;
    }
    this.groupChange.emit(this.group);
  }

  updateField(item){
    this.updateExampleFusion(item);
    this.groupChange.emit(this.group);
  }
  updateType(){
    this.groupChange.emit(this.group);
  }

  populateNumberType() {
    this.numberTypes = [
      {
        value: ConvertTypeTransformConf.TypeEnum.Int,
        label: "Nombre entier"
      },
      {
        value: ConvertTypeTransformConf.TypeEnum.BigInt,
        label: "Nombre entier (big)"
      },
      {
        value: ConvertTypeTransformConf.TypeEnum.Decimal112,
        label: "Nombre décimale (123456789,01)"
      },
      {
        value: ConvertTypeTransformConf.TypeEnum.Decimal52,
        label: "Nombre décimale (123,45)"
      },
      {
        value: ConvertTypeTransformConf.TypeEnum.Decimal82,
        label: "Nombre décimale (123456,78)"
      }
      /*,
       {
        value: "String10",
        label: "Texte (10)"
      },
      {
        value: "String100",
        label: "Text (100)"
      },
      {
        value: "String25",
        label: "Texte (25)"
      },
      {
        value: "String255",
        label: "Texte (255)"
      },
      {
        value: "String3",
        label: "Texte (3)"
      },
      {
        value: "String50",
        label: "Texte (50)"
      },
      {
        value: "TEXT",
        label: "Long text"
      },
      {
        value: "UUID",
        label: "UUID"
      },
      {
        value: "Boolean",
        label: "Binaire"
      },
      {
        value: "Date",
        label: "Date"
      },
      {
        value: "DateTime",
        label: "Date et heure"
      },
      {
        value: "Time",
        label: "Heure"
      } */
    ];
  }
}
